import React from 'react';
import css from './SymbolSharetribe.module.scss';
import classNames from 'classnames';
import Link from '@components/Link/Link';

const SymbolSharetribe = ({ mode = 'light' }) => {
  const logoClassName = classNames({
    [css.logoColorDark]: mode === 'dark',
    [css.logoColorLight]: mode === 'light',
    [css.logoColorCyan]: mode === 'cyan',
  });
  return (
    <Link to="/" className={css.logo} aria-label="Link to Sharetribe's homepage">
      <svg width="28" height="32" viewBox="0 0 23 26" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="nonzero">
          <path
            className={logoClassName}
            d="M22.0790323 6.25437788L11.7943548.2156682c-.2830645-.19170507-.6604838-.19170507-.9435483 0 0 0-.8491936.47926268-.8491936.57511521-1.13225806.67096774-1.60403225 2.01290323-.09435484 2.7797235C11.7 4.52903226 13.6814516 5.58341014 13.6814516 5.58341014c2.5475807 1.34193548 2.358871 2.20460829 2.358871 3.73824885v1.05437791L9.90725806 7.02119816c-.47177419-.19170507-.75483871 0-.75483871.47926267v1.53364055c0 .47926268.37741936 1.15023042.75483871 1.34193552l2.54758064 1.437788c1.3209678.7668203 3.5854839 1.6294931 3.5854839 3.1631336v8.3391705l6.0387097-3.3548387c.2830645-.191705.4717742-.4792627.4717742-.7668203V7.02119816c0-.28755761-.1887097-.57511521-.4717742-.76682028z"
          />
          <path
            className={logoClassName}
            d="M.37741936 19.7695853l10.28467744 6.0387096c.2830645.1917051.6604838.1917051.9435484 0 0 0 .8491935-.4792626.8491935-.5751152 1.1322581-.6709677 1.6040323-2.0129032.0943548-2.7797235C10.7564516 21.4949309 8.775 20.440553 8.775 20.440553c-2.54758065-1.246083-2.35887097-2.2046083-2.35887097-3.7382489v-1.0543778l6.13306447 3.3548387c.4717742.2875576.7548388 0 .7548388-.4792627v-1.5336405c0-.4792627-.3774194-1.1502305-.7548388-1.3419355l-2.5475806-1.4377881c-1.32096774-.7668202-3.58548387-1.629493-3.58548387-3.1631336V2.7078341L.37741936 6.06267281C.18870967 6.25437788 0 6.63778802 0 6.92534562V19.002765c0 .2875576.18870968.5751152.37741936.7668203z"
          />
        </g>
      </svg>
    </Link>
  );
};

export default SymbolSharetribe;
